import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Observable, catchError, throwError } from 'rxjs';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private messageService: MessageService) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                let errorMessage = 'An error occurred';

                // Check if the error is a text/html response
                if (typeof error.error === 'string') {
                    // For text/html responses, use a generic error message
                    errorMessage = 'Server returned an error. Please try again later.';
                } else if (error.status === 0) {
                    errorMessage = 'Cannot connect to server. Please check your internet connection.';
                } else if (error.status === 403) {
                    errorMessage = 'You do not have permission for this operation.';
                } else if (error.status === 401) {
                    errorMessage = 'Your session has expired!';
                } else if (error.status === 400) {
                    // Check if validation errors are present
                    if (error.error?.errorCode === 'validation-error' && error.error?.validationErrors) {
                        errorMessage = '';
                        for (const [key, value] of Object.entries(error.error?.validationErrors)) {
                            const validationMsg = (value as string[]) || [];
                            errorMessage += `${validationMsg.join(' \n')}  \n`;
                        }
                    } else {
                        errorMessage = error.error?.message || 'Invalid request.';
                    }
                } else if (error.status === 500 || error.status === 502) {
                    errorMessage = 'Server error occurred. Please try again later.';
                } else if (error.error?.message) {
                    errorMessage = error.error.message;
                }

                // Only show toast message if it's not a 401 or 404 error
                const excludedStatusCodes = [401, 404];
                if (!excludedStatusCodes.includes(error.status)) {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: errorMessage,
                        life: 5000
                    });
                }

                return throwError(() => error);
            })
        );
    }
}

// Provider array for easy import
import { HTTP_INTERCEPTORS } from '@angular/common/http';

export const errorInterceptorProviders = [{ provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }];
